import config from "src/config";
import { getData } from 'src/utils/axios/serverHelper';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { OrganizationDto, OrganizationTreeDto } from 'src/dtos/organization/organizationDto';

const baseUrl = `${config.apiUrl}/organiza`;

//조직 조회
export const getOrganizationList = async (searchText?: string) => {
  const url = `${baseUrl}/list`

  return await getData<ResponseDto<OrganizationDto[]>>(url, searchText ? {
    params: {
      searchText
    }
  } : undefined);
}


//조직 트리 조회
export const getOrganizationTreeList = async (searchText?: string) => {
	const url = `${baseUrl}/list/tree`
  
	return await getData<ResponseDto<OrganizationTreeDto[]>>(url, searchText ? {
	  params: {
		searchText
	  }
	} : undefined);
  }